import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';

@Component({
    selector: 'basket-view-expandable',
    templateUrl: './basket-view-expandable.html',
    styleUrls: ['./basket-view-expandable.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [HideUpComponent, CommonModule]
})
export class BasketViewExpandableComponent {
    @Input()
    expandableTitle?: string;

    toggleState = false;

    @Output()
    onClose = new EventEmitter();

    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    toggle(to = !this.toggleState) {
        this.toggleState = !this.toggleState;
        if (!to) {
            this.onClose.emit();
        }
        this.changeDetectorRef.detectChanges();
    }
}
